/**
 * USERS REQUESTS
 */

import { DOCTORS_URL } from "../apiUrl";
import Axios from "./axiosSetup";

/**
 * Registration
 * @param {*} formData
 * @returns
 */
export function DoctorRegister(formData: object) {
  return Axios.post(`${DOCTORS_URL}/register`, formData);
}

/**
 * Add patient
 * @param {*} formData
 * @returns
 */
export function DoctorAddPatient(formData: object) {
  return Axios.post(`${DOCTORS_URL}/add-patient`, formData);
}

/**
 * Create
 * @param {*} practitionerRoleId
 * @returns
 */
export function DoctorCreate(practitionerRoleId: string) {
  return Axios.post(`${DOCTORS_URL}`, {
    practitionerRoleId: practitionerRoleId,
  });
}

/**
 * Unsubscribe
 * @returns
 */
export const UnsubscribeDoctor = () => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem(
    "jwtToken"
  )}`;
  return Axios.post(`${DOCTORS_URL}/unsubscribe`, {
    // TODO raison
    raison: null,
  });
};

/**
 * Update User
 * @param {*} formData
 * @returns
 */
export function DoctorAuthLogin(formData: object) {
  return Axios.post(`${DOCTORS_URL}/auth/local`, formData);
}

/**
 * Update User
 * @param {*} formData
 * @returns
 */
export function DoctorAuthConfirmation(formData: object) {
  return Axios.post(`${DOCTORS_URL}/auth/confirmation`, formData);
}

/**
 * Edit doctor Request
 * @param formData
 * @returns
 */
export const EditDoctor = (doc_id: string, formData: any) => {
  return Axios.put(`${DOCTORS_URL}/${doc_id}`, formData);
};

/**
 * Get doctor Request
 * @param formData
 * @returns
 */
export const GetDoctor = (doc_id: string) => {
  return Axios.get(`${DOCTORS_URL}/${doc_id}`);
};

/**
 * remove patients request
 * @param patientsUid
 * @returns
 */
export function RemovePatients(patientsUid: string[]) {
  return Axios.post(`${DOCTORS_URL}/remove-patients`, patientsUid);
}

/**
 * search doctor
 * @param patientsUid
 * @returns
 */
export function DoctorSearch(formData: object) {
  return Axios.post(`${DOCTORS_URL}/search-doctor`, formData);
}

/**
 * save patient appointment uid Request
 * @returns
 */
export const SavePatientAppointment = (formData: any) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem(
    "jwtToken"
  )}`;
  return Axios.post(`${DOCTORS_URL}/save-appointment`, formData);
};

/**
 * Add patient
 * @param {*} formData
 * @returns
 */
export function DoctorConnectPatient(formData: object) {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem(
    "jwtToken"
  )}`;
  return Axios.post(`${DOCTORS_URL}/connect-patient`, formData);
}
